export default "__VITE_ASSET__CEcmAq7U__"